import React from 'react'
import styled from 'styled-components'
import { Field } from 'formik'

import Checkbox from './Checkbox'
import useLocalization from '../../utils/hooks/use-localization'
import Input from '../Input'

interface ICheckbox {
	groupLable: string
	name: string
	labels: string[]
	isRequired?: boolean
	otherTextArea?: boolean
	otherPlatformName?: string
}

const MultipleCheckbox = ({
	name,
	labels,
	isRequired = false,
	groupLable,
	otherTextArea = false,
	otherPlatformName,
}: ICheckbox) => {
	const { translate } = useLocalization()
	return (
		<>
			<GroupName>
				<h5>{groupLable}</h5>
				{isRequired && <Red>*</Red>}
			</GroupName>
			<Field name={name}>
				{({ field, form, meta: { touched, error } }) => {
					return (
						<>
							{labels.map((label, i) => {
								return (
									<Checkbox
										key={i}
										label={label}
										field={field}
										checked={field.value.includes(label)}
										onChange={(e) => {
											if (!form.values[name].includes(label)) {
												form.setFieldValue(name, [...field.value, label])
											} else {
												const nextValue = field.value.filter((value: string) => value !== label)
												form.setFieldValue(name, nextValue)
											}
										}}
									/>
								)
							})}
							{otherTextArea && (
								<>
									<Checkbox
										label={translate('other')}
										field={field}
										checked={field.value.includes(translate('other'))}
										onChange={(e) => {
											if (e.target.checked) {
												form.setFieldValue(name, [...field.value, translate('other')])
											} else {
												const nextValue = field.value.filter((value: string) => value !== translate('other'))
												form.setFieldValue(name, nextValue)
											}
										}}
									/>
									{field.value.includes(translate('other')) && otherPlatformName && (
										<Input
											name={otherPlatformName}
											type='textarea'
											placeholder={translate('other')}
											isRequired={false}
										/>
									)}
								</>
							)}
						</>
					)
				}}
			</Field>
		</>
	)
}

const Red = styled.h5`
	color: var(--orange);
`
const GroupName = styled.div`
	display: flex;
	align-items: center;
	margin-top: 16px;
	gap: 5px;

	h5 {
		margin: 0;
	}
`

export default MultipleCheckbox
